import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { OperationalMessage } from '../../../../core/model';
import { FeedFacade } from '../../../../core/user';
import { AlertsService } from '../../base/services';

@Component({
  selector: 'py-operational-message',
  templateUrl: './operational-message.component.html',
  styleUrls: ['./operational-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationalMessageComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  operationalMessage$: Observable<OperationalMessage>;

  constructor(
    private alertsService: AlertsService,
    private feedService: FeedFacade,
    private breakpointService: BreakpointService
  ) {}

  ngOnInit(): void {
    this.triggerFeedDataLoadOnMobile(); // operational messages need to be displayed immediately
    this.operationalMessage$ = this.alertsService.getOperationalMessage();
  }

  triggerFeedDataLoadOnMobile(): void {
    this.subscription.add(
      this.breakpointService
        .isDown(BREAKPOINT.md)
        .pipe(
          take(1),
          filter(Boolean),
          switchMap((_) => this.feedService.getFeedData())
        )
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
